import { render } from "./Highlight.vue?vue&type=template&id=6454c8a6"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import "./Highlight.vue?vue&type=style&index=0&id=6454c8a6&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__